import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  ArrowDownUp,
  ArrowUpDown,
  ShieldOff,
  ShieldX,
  SquareCheck,
  SquarePen,
  SquareX,
} from "lucide-react";
import ReactPaginate from "react-paginate";
import ParagraphTag from "../../reusebale/Paragraph";
import ImageTag from "../../reusebale/imageTag";
import NoData from "../../reusebale/noData";

import BaseUrl from "../../../constants/BaseUrl";
import db from "../../../db/index.json";

const LeasesTable = ({
  isViewDetails,
  onViewCreate,
  onViewDetailsTenant,
  search,
}) => {
  const { lease } = db;
  const { loginSuccess } = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(1);
  const [AllLeases, setAllLeases] = useState([]);
  const itemsPerPage = 10;

  function CalculateAdditionalCharges(item) {
    if (!item || !Array.isArray(item.additionalCharges)) {
      return "$ 0";
    }

    const total = item.additionalCharges.reduce((sum, charge) => {
      return sum + (Number(charge.amount) || 0);
    }, 0);

    return `$ ${total}`;
  }

  const GetAllLease = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/lease/getAllAvailableLeases/?page=${currentPage}&limit=${itemsPerPage}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const data = result.data.map((item) => ({
            ...item,
            duration: CalculateDaysBetween(item.startDate, item.endDate),
            rent: CalculateAdditionalCharges(item),
          }));
          setAllLeases(data);
          setTotalData(result.pagination.totalLeases);
        }
      })
      .catch((error) => console.error(error));
  };
  useEffect(() => {
    GetAllLease();
  }, [currentPage, loginSuccess?.token]);

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const onViewDetails = (status, id) => {
    isViewDetails(status, id);
  };

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...AllLeases].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setAllLeases(sortedData);
  };

  function CalculateDaysBetween(date1, date2) {
    // Parse the dates using Moment.js
    const startDate = moment(date1);
    const endDate = moment(date2);

    // Calculate the difference in days
    const daysDifference = endDate.diff(startDate, "days");

    return daysDifference;
  }

  return (
    <div className="h-full">
      <div className="bg-white w-full h-[87%]">
        <div className="w-[95%] mx-auto h-full">
          <div className="flex justify-between items-center h-[12%]">
            <div className="w-[70%]">
              <ParagraphTag
                content={lease.heading}
                classes="text-darkColor font-popinsSemiBold text-lg"
              />
            </div>
          </div>
          <div className="overflow-x-auto w-full h-[88%] panelScroll mt-1">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr className="border-b border-black/20">
                  <th className="w-[20%] text-left pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={lease.heading}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "lease" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("lease")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("property")}
                        />
                      )} */}
                    </span>
                  </th>
                  <th className="w-[20%] pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={lease.landlord}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "landlord" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("landlord")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("landlord")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("landlord")}
                        />
                      )} */}
                    </span>
                  </th>
                  <th className="w-[20%] pb-2">
                    <span className="flex">
                      <ParagraphTag
                        content={lease.tenant}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "tenant" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("tenant")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("tenant")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("tenant")}
                        />
                      )} */}
                    </span>
                  </th>

                  <th className="w-[18%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.duration}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pl-2"
                      />
                      {sortConfig.key === "duration" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("duration")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("duration")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("duration")}
                        />
                      )}
                    </span>
                  </th>

                  <th className="w-[12%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.units}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {/* {sortConfig.key === "units" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("units")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("units")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("units")}
                        />
                      )} */}
                    </span>
                  </th>
                  <th className="w-[10%] pb-2">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={lease.status}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "status" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("status")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("status")}
                        />
                      )}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {AllLeases.map((item) => {
                  const TenantName = `${item?.tenantInfo.firstName} ${item?.tenantInfo.lastName}`;
                  if (
                    item?.propertyInfo?.propertyName
                      ?.toUpperCase()
                      ?.includes(search.toUpperCase()) ||
                    item.unitInfo.unitName
                      ?.toUpperCase()
                      ?.includes(search.toUpperCase()) ||
                    TenantName?.trim()
                      ?.toUpperCase()
                      ?.includes(search.toUpperCase())
                  ) {
                    return (
                      <tr
                        key={item.id}
                        className="hover:bg-gray-100 rounded-md cursor-pointer"
                      >
                        <td className="py-2">
                          <div className="flex items-center justify-between">
                            <div className="w-[18%] rounded-full">
                              <ImageTag
                                path="/assets/daashboard/balance.png"
                                classes="w-full"
                                altText="logo"
                              />
                            </div>

                            <div
                              className="w-[78%] cursor-pointer"
                              onClick={() => {
                                onViewDetails(item.status, item._id);
                              }}
                            >
                              <ParagraphTag
                                content={`PID-${item?._id?.slice(0, 10)}`}
                                classes="text-darkColor/50 font-popinsMedium text-xs"
                              />
                              <ParagraphTag
                                content={item?.propertyInfo?.propertyName}
                                classes="text-darkColor font-popinsSemiBold text-sm"
                              />
                            </div>
                          </div>
                        </td>
                        <td className="py-2">
                          <div className="flex items-center justify-between">
                            <div className="w-[25%] rounded-full">
                              <ImageTag
                                path={
                                  item?.landlordCompleteProfile
                                    ?.personalInformation?.profileImage?.url ||
                                  "/assets/daashboard/landlord-color.png"
                                }
                                classes="w-[45px] h-[45px] rounded-full"
                                altText="logo"
                              />
                            </div>
                            <div className="w-[75%] cursor-pointer">
                              <ParagraphTag
                                content={`LID-${item?.propertyInfo?.landlordId?.slice(
                                  0,
                                  10
                                )}`}
                                classes="text-darkColor/50 font-popinsMedium text-xs"
                              />
                              <ParagraphTag
                                content={`${item?.landlordCompleteProfile?.personalInformation?.firstName} ${item?.landlordCompleteProfile?.personalInformation?.lastName}`}
                                classes="text-darkColor font-popinsSemiBold text-sm"
                              />
                            </div>
                          </div>
                        </td>
                        <td className="py-2">
                          <div className="flex items-center justify-between">
                            <div
                              className="w-fullcursor-pointer"
                              onClick={() => {
                                onViewDetailsTenant(item?.tenantInfo);
                              }}
                            >
                              <ParagraphTag
                                content={`TEN-${item?.tenantInfo._id?.slice(
                                  0,
                                  10
                                )}`}
                                classes="text-darkColor/50 font-popinsMedium text-xs"
                              />
                              <ParagraphTag
                                content={`${item?.tenantInfo?.firstName} ${item?.tenantInfo?.lastName}`}
                                classes="text-darkColor font-popinsSemiBold text-sm"
                              />
                            </div>
                          </div>
                        </td>

                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-xs text-center">
                          <div className="flex flex-col">
                            <span>{`${moment(item?.startDate).format(
                              "MM/DD/YYYY"
                            )} - ${moment(item?.endDate).format(
                              "MM/DD/YYYY"
                            )}`}</span>
                            <span className="text-darkColor/50">{`${CalculateDaysBetween(
                              item?.startDate,
                              item?.endDate
                            )} Days left`}</span>
                          </div>
                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                          {item?.unitInfo.unitName}
                        </td>
                        <td className="py-2 px-4 font-popinsMedium text-darkColor text-sm text-center">
                          <div className="flex justify-center items-center">
                            <span>
                              {(() => {
                                switch (item.status) {
                                  case "active":
                                    return (
                                      <SquareCheck color="#01CB78" size={20} />
                                    );
                                  case "draft":
                                    return (
                                      <SquarePen color="#e38979" size={20} />
                                    );
                                  case "rejected":
                                    return (
                                      <SquareX color="#E43B3B" size={20} />
                                    );
                                  case "inActive":
                                    return (
                                      <ShieldOff color="#BFCDDB" size={20} />
                                    );
                                  default:
                                    return (
                                      <ShieldX color="#FF0000" size={20} />
                                    );
                                }
                              })()}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
            {AllLeases.length === 0 && (
              <div className="w-full flex justify-center mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center h-[13%] items-center">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={Math.ceil(totalData / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName="flex space-x-2 items-center"
          pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
          previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
          nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
          disabledClassName="opacity-50 !cursor-not-allowed"
          activeClassName="bg-themeColor text-white"
          breakClassName="px-3 py-1 text-sm font-popinsMedium"
        />
      </div>
    </div>
  );
};

export default LeasesTable;
